import { delayedCall, dispatcher, IEvent, ingenuity, killDelayedCall, SpineBase } from "@quest/base-core";
import { ReelPanelController, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotEventConstants, SymbolBase } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";

/**
 * ReelPanelControllerGame class hanles the slot reel functionality for the base game.
 */
export class ReelPanelControllerGame extends ReelPanelController {
  private cascadeOnReelsCounter: number = 0;

  protected onSpinReel(evt: IEvent): void {
    super.onSpinReel(evt);
    dispatcher.fireEvent(eventDispatchers.RESET_FS_BAR);
  }

  /**
   * subscribe all events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL, this.updateGridStaticSymbolAfterMoney, this);
    dispatcher.on(eventDispatchers.CASCADE_SPIN_COMPLETE, this.onCascadeSpinComplete, this);
    dispatcher.on(eventDispatchers.SPECIAL_SYMBOL_OUT_ANIM,this.playSpecialSymbolOutAnim,this);
    dispatcher.on(eventDispatchers.HIDE_SYMBOL_ON_REEL,this.removeReelSymbols,this)
  }

  /**
   * unsubscribe all events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.CASCADE_SPIN_COMPLETE, this.onCascadeSpinComplete, this);
    dispatcher.off(eventDispatchers.SPECIAL_SYMBOL_OUT_ANIM,this.playSpecialSymbolOutAnim,this)
  }

  private playSpecialSymbolOutAnim():void{
     let trailData = (ingenuity.parserModel as GameParserModel).getSpecialSymbolData();
    trailData.forEach((data:any) => {
      this.playSymbolAnimation(data.offset, 'out');
      delayedCall('startSymbolTrail111',gameConstants.TIMER_500,()=>{
      killDelayedCall('startSymbolTrail1111');
      this.updateGridStaticSymbol(data.offset)
    })
    });
    delayedCall('startSymbolTrail',gameConstants.TIMER_500,()=>{
      killDelayedCall('startSymbolTrail');
      dispatcher.fireEvent(eventDispatchers.START_SCATTER_TRAIL);
    })
  }

  private playSymbolAnimation(offset:number[],animName:string):void{
    let symbol: SymbolBase = this.reelView.getSymbolByPos(offset[0], offset[1] + gameConstants.OFFSET_INCREMENT_X5);
    let staticSym = symbol.getStatic();
    let animSym: SpineBase = symbol.getAnimation() as SpineBase;
    staticSym.visible = false;
    this.reelView?.getAnimReels()[offset[0]].addChild(animSym);
    animSym.visible = true;
    setTimeout(() => {
      animSym.playAnim(animName, false);
    }, 1);
  }

  private removeReelSymbols(evt:IEvent):void{
    let reelId = evt.data[0];
    let col = evt.data[1] + gameConstants.OFFSET_INCREMENT_X5;
    this.reelView.getSymbolByPos(reelId, col).getStatic().visible = false;
    this.reelView.getSymbolByPos(reelId, col).getAnimation().visible = false;
  }

  private updateGridStaticSymbol(offset:number[]):void{
    let reelId = offset[0];
    let col = offset[1] + gameConstants.OFFSET_INCREMENT_X5;
      let reelGrid = this.model.getReelGrid();
      let symbol = reelGrid[reelId][col]
      if(symbol == gameConstants.SPECIAL_SYMBOL_NOTE_ID){
        reelGrid[reelId][col] = gameConstants.NOTE_BLANK_SYMBOL_ID;
      } else if(symbol == gameConstants.SPECIAL_SYMBOL_MAGNIFY_ID){
        reelGrid[reelId][col] = gameConstants.MAGNIFY_BLANK_SYMBOL_ID;
      } else {
        reelGrid[reelId][col] = gameConstants.KEY_BLANK_SYMBOL_ID;
      }
      this.reelView.showStaticGrid(reelGrid);
      (ingenuity.parserModel as GameParserModel).setReelGrid(reelGrid);
      (ingenuity.parserModel as GameParserModel).setBaseGameReelSetWithStack(reelGrid);
      this.reelView.getSymbolByPos(reelId, col).getStatic().visible = true;
  }

   private updateGridStaticSymbolAfterMoney(evt:IEvent):void{
    let offset:number[] = evt.data.offset;
    let updatedSymbolId:number = evt.data.symbolId;
    let reelId = offset[0];
    let col = Number(offset[1]) + gameConstants.OFFSET_INCREMENT_X5;
      let reelGrid = this.model.getReelGrid();
      reelGrid[reelId][col] = updatedSymbolId;
      this.reelView.showStaticGrid(reelGrid);
      (ingenuity.parserModel as GameParserModel).setReelGrid(reelGrid);
      (ingenuity.parserModel as GameParserModel).setBaseGameReelSetWithStack(reelGrid);
      this.reelView.getSymbolByPos(reelId, col).getStatic().visible = true;
  }

  /**
   * This method is use to show win after cascading is completed
   */
  private onCascadeSpinComplete(): void {
    this.cascadeOnReelsCounter += 1;
    if (this.cascadeOnReelsCounter === (ingenuity.parserModel as GameParserModel).getCurrentCascadingReelNumber()) {
      this.cascadeOnReelsCounter = 0;
      const currenCascadeCount: number = (ingenuity.parserModel as GameParserModel).getCascadingCount();
      (ingenuity.parserModel as GameParserModel).setCascadingCount(currenCascadeCount - 1);
      if ((ingenuity.parserModel as GameParserModel).getCascadeWin()) {
        dispatcher.fireEvent(eventDispatchers.SHOW_CASCADE_WIN);
      } else {
        dispatcher.fireEvent(
          eventDispatchers.ON_CASCADE_COMPLETE_UPDATE_FS_BAR,
          (ingenuity.parserModel as GameParserModel).getTotalCascadeNumber()
        );
      }
    }
  }

  // Overrided to handle landing anim
  protected handleScatterLanding(eventIndex: any, value: any) {
    //dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_LANDING_SOUNDS, value);
    dispatcher.fireEvent(SlotEventConstants.SHOW_LANDINGANIMATION, [this.model.getReelGrid(), this.reelView, eventIndex]);
  }

  protected onSpinComplete(evt?: IEvent): void {
    (ingenuity.parserModel as GameParserModel).setIsSpinClicked(false);
    ingenuity.configData.spinComplete = true;
    this.reelView.getModel().quickSpin = false;
    this.reelView.setStopNow(false);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_IS_REEL_SPINNING, false);
    dispatcher.fireEvent(SlotEventConstants.CHECK_FOR_WIN_AFTER_REEL_STOP);
  }
}
